import { render, staticRenderFns } from "./PagesConfig.vue?vue&type=template&id=4d653301&scoped=true&"
import script from "./PagesConfig.vue?vue&type=script&lang=js&"
export * from "./PagesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d653301",
  null
  
)

export default component.exports